import { IntlShape } from 'react-intl';

type FormatAmountProps = {
  value: number;
  intl: IntlShape;
};

export const formatAmount = ({ value, intl }: FormatAmountProps): string => {
  if (value < 1000000) {
    return intl.formatNumber(value);
  }

  const SUFFIX = {
    de: ' Mio.',
    en: 'M',
  };

  const suffix: string =
    SUFFIX[intl.locale.toLocaleLowerCase() === 'de' ? 'de' : 'en'];

  // transform in decimal (e.g. 1840000 -> 1.84), formats and adds suffix
  return `${intl.formatNumber(Math.round(value / 10000) / 100)}${suffix}`;
};
